var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all-wrapper menu-side with-pattern",staticStyle:{"padding-top":"20px"}},[_c('router-view',{attrs:{"name":"content"}}),_c('div',{staticClass:"app-version"},[_vm._v("ver "+_vm._s(_vm.appVersion))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }